import { render, staticRenderFns } from "./TheMystery.vue?vue&type=template&id=b9c9f5ec&scoped=true"
import script from "./TheMystery.vue?vue&type=script&lang=js"
export * from "./TheMystery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c9f5ec",
  null
  
)

export default component.exports